import { DeliveryProduct } from '../../../../data/entities';

export type DeliveryRow = DeliveryProduct & { delivery_trip_item_id?: string; rowKey: string; delivery_address: string; addressTouched?: boolean; delivery_allocations?: { quantity: number; delivery_address: string }[] };
let sequence = 0;
export const rowKey = () => `delivery-row-${++sequence}`;
export const entityKey = (item: DeliveryProduct) => `${item.product ? 'PRODUCT' : 'MATERIAL'}:${item.product?.id || item.material?.id || item.id}`;

// Expand routing rows only in the editor. Inventory/export/returns still see one
// canonical line per product, with the sum of all delivery destinations.
export function expandDeliveryRows(items: any[], fallbackAddress: string): DeliveryRow[] {
    return items.flatMap(item => {
        const allocations = item.delivery_allocations?.length ? item.delivery_allocations : [{quantity: item.quantity, delivery_address: item.delivery_address ?? fallbackAddress}];
        return allocations.map((allocation: any, index: number) => ({
            ...item, ...allocation, rowKey: rowKey(),
            delivery_trip_item_id: item.delivery_trip_item_id || (item.sale_order_item_id ? item.id : undefined),
            returned_quantity: index === 0 ? (item.returned_quantity || 0) : 0,
        }));
    });
}

export function aggregateDeliveryRows(rows: DeliveryRow[]): any[] {
    const grouped = new Map<string, any>();
    rows.forEach(row => {
        const key = entityKey(row);
        const item = grouped.get(key) || {...row, quantity: 0, returned_quantity: 0, delivery_allocations: []};
        item.delivery_trip_item_id ||= row.delivery_trip_item_id;
        item.quantity += Number(row.quantity || 0);
        item.returned_quantity += Number(row.returned_quantity || 0);
        item.delivery_allocations.push({quantity: Number(row.quantity), delivery_address: row.delivery_address.trim()});
        grouped.set(key, item);
    });
    return Array.from(grouped.values());
}

export function deliveryAddressLabel(items: any[], fallback: string): string {
    if (!items.length) return '';
    const addresses = new Set<string>();
    items.forEach(item => (item.delivery_allocations?.length ? item.delivery_allocations : [{delivery_address: item.delivery_address || fallback}])
        .forEach((row: any) => { if (row.delivery_address?.trim()) addresses.add(row.delivery_address.trim()); }));
    return addresses.size > 1 ? `${addresses.size} địa chỉ` : Array.from(addresses)[0] || fallback || '';
}

export function singleDeliveryAddress(rows: DeliveryRow[]): string {
    const addresses = new Set(rows.map(row => row.delivery_address.trim()).filter(Boolean));
    return addresses.size === 1 ? Array.from(addresses)[0] : '';
}
